import { Typography, useTheme } from "@mui/material";
import Card from "components/common/card/Card.component";
import React from "react";

const TitleSectionComponent = ({
    title,
    children,
    direction = 'row',
    ...sx
}) => {
    const theme = useTheme()

    return (<Card sx={{ display: 'flex', flexDirection: direction }}>
        <Typography
            sx={{
                fontWeight: 500,
                fontSize: 18,
                color: theme.palette.mode === "dark" ? "white" : "black",
                ...sx
            }}
        >
            {title}
        </Typography>
        {children}
    </Card>)
}

export default TitleSectionComponent